module.exports = __webpack_public_path__ + "img/smartphone-586944_1920.855cb25c.jpg";